import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=24d33b9e&scoped=true"
import script from "./SidePanel.vue?vue&type=script&lang=js"
export * from "./SidePanel.vue?vue&type=script&lang=js"
import style0 from "./SidePanel.vue?vue&type=style&index=0&id=24d33b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d33b9e",
  null
  
)

export default component.exports